<!-- Do not change this file. -->

<template>
  <div class="alert alert-warning text-dark text-start p-0">
    <div class="fw-bold h5 text-uppercase pt-2 ps-2">(Vuex) Auth / JWT</div>
    <table class="table table-striped m-0 p-0" aria-label="(Vuex) Auth / JWT">
      <tbody>
        <tr>
          <th>Name</th>
          <td>{{ getFullname }}</td>
        </tr>
        <tr>
          <th>Role</th>
          <td>{{ getRole }}</td>
        </tr>
        <tr>
          <th>ONID</th>
          <td>{{ getOnid }}</td>
        </tr>
        <tr>
          <th>Session</th>
          <td>{{ getSession }}</td>
        </tr>
        <tr>
          <th>Expiration</th>
          <td>{{ getExpirationTime }}</td>
        </tr>
        <tr>
          <th>Remaining</th>
          <td>{{ formatExpirationTimeRemaining }} min</td>
        </tr>
        <tr>
          <th>Token</th>
          <td>
            <textarea
              class="form-control"
              :value="getToken"
              rows="4"
              disabled
            ></textarea>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
/* Do not change this file. */

import { mapGetters } from "vuex";

export default {
  name: "DebugAuth",
  computed: {
    ...mapGetters([
      "getToken",
      "getFullname",
      "getRole",
      "getOnid",
      "getSession",
      "getExpirationTime",
      "getExpirationTimeRemaining"
    ]),
    formatExpirationTimeRemaining() {
      return Math.round(this.getExpirationTimeRemaining / 60);
    }
  }
};
</script>
